import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/storage-facilities-that-ship.jpg'),
    alt: 'storage facilities that ship page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage facilities that ship page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Simple and <span>Reliable</span><span>Storage Facilities That Ship Fast</span>',
  description:
    'ShipAndStorage offers seamless solutions for those looking for reliable storage facilities that ship items anywhere, anytime. With flexible options and global reach, we ensure secure and efficient service.',
  points: [
    'Up to 6 Months Free Storage',
    'Free Insurance up to $250',
    '1 Small Box to 100 Large Box Storage',
    'Storage Services with Freedom'
  ],
  image: {
    url: '/images/v2/pages/landing-pages/storage-facilities-that-ship/hero-image.svg',
    alt: 'storage facilities that ship page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Secure Storage Facilities' }
}

export const helperGuideSection = {
  title: 'How Our Reliable Storage Facilities Work',

  ctaButton: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Learn More' },
  cards: [
    {
      id: 1,
      title: 'Book Your Storage & Shipping',
      description:
        'Easily schedule your storage and shipping services with our simple online booking system, designed for convenience and speed.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/book-your-storage-shipping-with-ease.svg',
        alt: 'Book Your Storage & Shipping with Ease service'
      }
    },
    {
      id: 2,
      title: 'We Handle Pickup & Delivery',
      description:
        'Enjoy hassle-free service as we pick up your items from your location and deliver them securely to our storage facility.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/we-handle-pickup-delivery.svg',
        alt: 'We Handle Pickup & Delivery service'
      }
    },
    {
      id: 3,
      title: 'Fast, Global Shipping When You Need It',
      description:
        "When you're ready to ship, we offer fast, reliable delivery worldwide with our trusted global shipping partners.",
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/fast-global-shipping-when-you-need-it.png',
        alt: 'Fast, Global Shipping When You Need It service'
      }
    },

    {
      id: 4,
      title: 'Convenient Ship To Storage Facility',
      description:
        'At ShipAndStorage, we pride ourselves on providing fast, reliable storage and shipping services. Whether you need to store a few items or an entire household, our storage facilities that ship are ready to meet your needs with speed and efficiency.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/convenient-ship-to-storage-facility.svg',
        alt: 'Convenient Ship To Storage Facility service'
      }
    }
  ]
}

export const whySelfStorageSectionContent = {
  title: 'Why Self Storage Service Is Necessary?',

  cards: [
    {
      id: 1,
      title: 'Clear Out Your Space',
      description:
        'Maximize your home or office space by keeping items you rarely use in storage. Our solutions create a more organized and tidy environment for you',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/clear-out-your-space.svg',
        alt: 'Clear Out Your Space'
      }
    },
    {
      id: 2,
      title: 'Simplify Your Moving Experience',
      description:
        'Easily navigate your relocation by using temporary storage for your belongings. Store furniture, appliances, and essentials until you’re ready to transport them.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/simplify-your-moving-experience.svg',
        alt: 'Simplify Your Moving Experience'
      }
    },
    {
      id: 3,
      title: 'Safe Storage for Seasonal and Personal Items',
      description:
        'Keep your seasonal decorations, sports equipment, or treasured possessions secure in our storage facilities, available for both short-term and long-term needs.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/safe-storage-for-seasonal-and-personal-items.svg',
        alt: 'Safe Storage for Seasonal and Personal Items'
      }
    }
  ]
}

export const gridSectionContent = {
  title: 'Who Should Choose Our Ship to Storage Facility Service?',
  description:
    'ShipAndStorage’s Ship to Storage Facility service is designed for customers who need a simple and efficient way to store items directly at our facility.',

  cards: [
    {
      id: 1,
      title: 'Frequent Travelers',
      description:
        'Perfect for those who need to securely store luggage or personal items while abroad or on extended trips.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/frequent-travelers.svg',
        alt: 'Frequent Travelers'
      }
    },
    {
      id: 2,
      title: 'College Students',
      description:
        'Ideal for students needing temporary storage between semesters, without the hassle of moving items back and forth.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/college-students.svg',
        alt: 'College Students'
      }
    },
    {
      id: 3,
      title: 'Small Businesses and Startups',
      description:
        'A convenient solution for extra inventory, office supplies, or equipment storage, helping businesses keep their workspaces clear and organized.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/small-businesses-and-startups.svg',
        alt: 'Small Businesses and Startups'
      }
    },

    {
      id: 4,
      title: 'Homeowners in Transition',
      description:
        'Provides a secure option for storing items during moves or renovations, allowing flexibility and peace of mind.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/homeowners-in-transition.svg',
        alt: 'Homeowners in Transition'
      }
    },
    {
      id: 5,
      title: 'Outdoor Enthusiasts and Hobbyists',
      description:
        'Great for those with large, seasonal equipment-like camping gear, sports gear, or tools-who want safe storage between uses.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/outdoor-enthusiasts-and-hobbyists.png',
        alt: 'Outdoor Enthusiasts and Hobbyists'
      }
    },
    {
      id: 6,
      title: 'E-commerce Sellers',
      description:
        'Efficient for managing stock overflow or seasonal items, with the ease of shipping directly to our facility.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/e-commerce-sellers.svg',
        alt: 'E-commerce Sellers'
      }
    }
  ]
}

export const evenOddList = {
  title: 'Our Different Storage Services',

  articles: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Secure, scalable storage options for businesses of all sizes, with global shipping to meet your business needs.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/business-storage-solution.svg',
        alt: 'Business Storage Solution'
      },
      link: {
        text: 'Explore Business Storage',
        href: PUBLIC_MAIN_ROUTES.BUSINESS_STORAGE.href
      }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Flexible moving and storage options for residential and commercial moves, with safe transport to our storage facilities.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/moving-storage-solution.svg',
        alt: 'Moving Storage Solution'
      },
      link: {
        text: 'Explore Moving Storage',
        href: PUBLIC_MAIN_ROUTES.MOVING_STORAGE_SOLUTIONS.href
      }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'We provide secure luggage and box shipping services with international delivery, perfect for students, travelers, or relocations.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/luggage-and-box-shipping-services.svg',
        alt: 'Luggage and Box Shipping Services'
      },
      link: {
        text: 'Explore Luggage & Box Shipping',
        href: PUBLIC_MAIN_ROUTES.LUGGAGE_BOX_SHIPPING_SERVICES.href
      }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Store your household items with ease and enjoy flexible storage terms and delivery services to your new location whenever you’re ready.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/residential-storage-services.svg',
        alt: 'Residential Storage Services'
      },
      link: {
        text: 'Explore Residential Storage',
        href: PUBLIC_MAIN_ROUTES.RESIDENTIAL_STORAGE.href
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose ShipAndStorage for Storage Facilities?',
  description:
    'Trust in our proven expertise and commitment to excellence, ensuring your shipping and storage needs are met with reliability and care.',

  cards: [
    {
      id: 1,
      title: 'Flexible, Affordable Plans',
      description:
        'Our storage facilities offer flexible payment plans and affordable pricing, making it easier for you to store your items without breaking the bank.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/flexible-affordable-plans.svg',
        alt: 'Flexible, Affordable Plans'
      }
    },
    {
      id: 2,
      title: 'Global Shipping Partners',
      description:
        'Partnering with trusted global couriers like FedEx, DHL, and UPS, we ensure fast and reliable shipping wherever you need it.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/global-shipping-partners.png',
        alt: 'Global Shipping Partners'
      }
    },
    {
      id: 3,
      title: 'Hassle-Free Service',
      description:
        'From pickup to delivery, we handle everything, so you can focus on what matters most without worrying about your storage or shipment.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/hassle-free-service.svg',
        alt: 'Hassle-Free Service'
      }
    }
  ]
}

export const infoBannerSectionContent = {
  id: 1,
  title: 'Storage Facilities That Ship Fast and Securely',
  description:
    'Reliable storage facilities that ship quickly and securely. Fast, affordable, and safe solutions for storing and shipping your belongings.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-facilities-that-ship/storage-facilities-that-ship-fast-and-securely.svg',
    alt: 'Storage Facilities That Ship Fast and Securely'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started' }
}

export const faqSectionContent = {
  title: 'Our Shipping Partners',
  description:
    "At ShipAndStorage, we partner with some of the world's most reliable carriers, including FedEx, DHL, and UPS, to offer unmatched shipping and storage services globally.",

  questions: [
    {
      id: 1,
      question: 'FedEx',
      answer:
        'Founded in 1971 by Frederick W. Smith, FedEx began with just 186 packages and has since grown into a global shipping leader. With a vast fleet of 696 aircraft and 215,000 vehicles, FedEx processes 16 million shipments daily across more than 220 countries and territories. Backed by over 550,000 employees and 5,000+ centers worldwide, FedEx ensures dependable, on-time deliveries for your storage and shipping needs.|||Disclaimer – FedEx Luggage Shipping Services|||The information was last updated in September 2024 for reference purposes. FedEx provides no express or implied warranties regarding the accuracy of the data.|||For further information, visit FedEx.com. FedEx® is a registered trademark. © 1995-2024 FedEx.'
    },
    {
      id: 2,
      question: 'DHL',
      answer:
        'DHL Express, part of Deutsche Post DHL Group, is a global leader in logistics and international courier services. Handling over 1.8 billion parcels annually, DHL plays a crucial role in the worldwide supply chain. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became fully owned by Deutsche Post in 2002 and now operates in over 220 countries, providing quick and reliable shipping solutions to customers across the globe.|||Disclaimer:|||The information was last updated in September 2024 for reference purposes. DHL makes no warranties regarding its accuracy.|||For further information, visit DHL.com. DHL® is a registered trademark of DHL International GmbH. All rights reserved.'
    },
    {
      id: 3,
      question: 'UPS',
      answer:
        'UPS started as the American Messenger Company in Seattle in 1907, founded by teenagers Claude Ryan and Jim Casey. Rebranded as United Parcel Service (UPS) in 1919, UPS has grown into one of the largest shipping companies in the world. With a daily volume of 25 million packages and a workforce of over 500,000 employees, UPS serves more than 220 countries, ensuring a global reach for all your storage and shipping needs.|||Disclaimer:|||The information was last updated in September 2024 for reference purposes. UPS provides no warranties regarding its accuracy.|||For further information, visit UPS.com. UPS® is a registered trademark of UPS Inc. All rights reserved.'
    }
  ]
}
